import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  FormFeedback,
  CustomInput,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import Flatpickr from "react-flatpickr";

//import images

import usePersistStoreData from "../../../Components/Hooks/usePersistStoreData";
import { ProfileDetailThunk } from "../../../slices/auth/login/thunk";
import { useDispatch } from "react-redux";

import EsignConfirmationModal from "../../../Components/Modals/EsignConfirmationModal";
import CommonLoading from "../../../Components/Common/CommonLoading";
import { profile_add_imageThunk } from "../../../slices/thunks";
import { useSelector } from "react-redux";
import { showToast } from "../../../Components/ToastNotification";
import Message from "../../../Components/Common/Message";

const EditOptions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { userData } = usePersistStoreData();
  const isSubmitted = userData?.rekcy_appication_status === "submitted";
  const [selectedOption, setSelectedOption] = useState(isSubmitted ? "2" : "1");

  const token = userData?.token;
  //   console.log("userData", userData);
  const [loading, setLoading] = useState(false);
  const isDisabled = userData?.trade?.account_status;

  // Convert numeric status into boolean for disable
  const isActive = isDisabled === 0 || isDisabled === 3;

  const { profileAddImageLoading } = useSelector(
    (state) => state.Add_Profile_Image
  );

  const [previewUrl, setPreviewUrl] = useState(null);
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
  const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];

  // data for edit options
  const editOptionsData = [
    {
      label: "KYC Reactivation/Modification",
      value: "1",
      disabled: isSubmitted,
      description:
        " (As per NSE and BSE circulars, when there has been no trading activity for 12 consecutive months, exchanges consider the account inactive, we mark such accounts for rekyc. The account can be reactivated by verifying the KYC details.)",
    },
    {
      label: "Add Nominee",
      value: "2",
      disabled: isActive,
      description:
        " (A nominee can be added online if not added earlier or you can edit the existed nominee details. It is important to add nominees so that the intended person can claim the securities easily in case of any unexpected event.)",
    },
    {
      label: "Annual Income",
      value: "3",
      disabled: isActive,
      description:
        " (The Annual Income tool allows users to easily modify and manage their yearly income figures.)",
    },
    {
      label: "Add Margin Trading Funding (optional)",
      value: "4",
      disabled: isActive,
      description:
        " (MTF (Margin Trading Funding) allows you to buy additional securities on margin.)",
    },
    {
      label: "Account Closure",
      value: "5",
      disabled: isActive,
      description:
        " (Account closure is permanent and irreversible. Please be aware that you'll lose access to features and your account data will be deleted.)",
    },
  ];

  // When user selects a file
  const onImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!ALLOWED_TYPES.includes(file.type)) {
      showToast("Invalid file type. Only JPEG, JPG, PNG are allowed.", "error");
      return;
    }

    // Validate file size
    if (file.size > MAX_FILE_SIZE) {
      showToast("File too large. Maximum size is 2 MB.", "error");
      return;
    }
    // Store current preview to revert if upload fails
    const previousPreview = previewUrl;

    // Show a preview immediately
    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);

    const form = new FormData();
    form.append("profile_image", file); // use your backend’s expected key
    dispatch(profile_add_imageThunk({ body: form, token }))
      .unwrap()
      .then(() => showToast("Profile image uploaded successfully.", "success"))
      .catch(() => {
        showToast("Failed to upload profile image.", "error");
        setPreviewUrl(previousPreview);
      });
  };

  const handleContinue = () => {
    if (selectedOption == "1") {
      navigate("/edit_profile", {
        state: { tab: selectedOption },
      });
    } else if (selectedOption == "2") {
      navigate("/add_nominee");
    } else if (selectedOption == "3") {
      navigate("/add_annualIncome");
    } else if (selectedOption == "4") {
      navigate("/add_mtf");
    } else if (selectedOption == "5") {
      navigate("/account_closure");
    } else {
      navigate("/edit_profile", {
        state: { tab: selectedOption },
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    dispatch(ProfileDetailThunk(userData?.token))
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [userData?.token]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <>
              <div className="position-relative mx-n4 mt-n4">
                <div
                  className="profile-wid-bg profile-setting-img"
                  style={{ backgroundColor: "#01256D" }}
                >
                  {/* <img src={progileBg} className="profile-wid-img" alt="" /> */}
                  <div className="overlay-content">
                    <div className="text-end p-3">
                      <div className="p-0 ps-2 ms-auto rounded-circle profile-photo-edit">
                        <Nav
                          pills
                          className=" animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                          role="tablist"
                        >
                          <NavItem>
                            <NavLink
                              // className={classnames(" ", {
                              //   active: activeTab === "1",
                              // })}
                              onClick={() => {
                                navigate("/profile");
                              }}
                              style={{
                                backgroundColor: "transparent",
                                border: "1px solid #0FA67B",
                              }}
                            >
                              <svg
                                className="me-2"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.99 9L16 9L16 7L3.99 7L3.99 4L3.49691e-07 8L3.99 12L3.99 9Z"
                                  fill="#0FA67B"
                                />
                              </svg>
                              <span className="d-none d-md-inline-block">
                                Go Back
                              </span>
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Loading spinner overlay */}
              {profileAddImageLoading && (
                <div className="position-absolute top-50 start-50 translate-middle">
                  <Spinner size="sm" />
                </div>
              )}
              <Row>
                <Col xxl={3} xl={3}>
                  <Card className="mt-n5">
                    <CardBody className="p-4">
                      <div className="text-center border-bottom mb-3">
                        <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                          <div
                            className={
                              profileAddImageLoading
                                ? "blur-wrapper_profile"
                                : ""
                            }
                          >
                            {previewUrl ? (
                              <img
                                src={previewUrl}
                                className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                                alt="user-profile"
                              />
                            ) : userData?.profile_image ? (
                              <img
                                src={userData.profile_image}
                                className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                                alt="user-profile"
                              />
                            ) : (
                              <i
                                className="mdi mdi-account-circle text-muted"
                                style={{ fontSize: "5rem" }}
                              />
                            )}
                          </div>

                          <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                            <Input
                              id="profile-img-file-input"
                              type="file"
                              accept="image/jpeg,image/jpg,image/png"
                              className="profile-img-file-input"
                              onChange={onImageChange}
                            />
                            <Label
                              htmlFor="profile-img-file-input"
                              className="profile-photo-edit avatar-xs"
                            >
                              <span className="avatar-title rounded-circle bg-light text-body">
                                <i className="ri-camera-fill"></i>
                              </span>
                            </Label>
                          </div>
                        </div>
                        <h5 className="fs-16 mb-3">{userData?.name}</h5>
                      </div>
                      <div className="d-flex flex-column mb-0">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="mb-0 ps-0 fs-p-sm w-50 text-start">
                            Client ID :
                          </p>
                          <p className="mb-0 fs-p-sm w-50 text-start">
                            {" "}
                            {`${userData?.trade?.dp_id}${userData?.trade?.dp_account_number}`}
                          </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="mb-0 ps-0 fs-p-sm w-50 text-start">
                            Mobile Number :
                          </p>
                          <p className="mb-0 fs-p-sm w-50 text-start">
                            {`+91 ${userData?.personal_details?.mobile}`}
                          </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="mb-0 ps-0 fs-p-sm w-50 text-start">
                            Email Id :
                          </p>
                          <p className="mb-0 fs-p-sm w-50 text-start">
                            {` ${userData?.personal_details?.email}`}
                          </p>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col xxl={9} xl={9}>
                  <Card className="mt-xxl-n5 mt-xl-n5">
                    <CardHeader>
                      <h5 className="card-title mb-0">Select Edit Option</h5>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        {isSubmitted && (
                          <Col className="col-12">
                            <Message
                              message="Your re-KYC request has been submitted and is currently under verification. The approval process may take 2–10 days."
                              color="success"
                              mb={3}
                            />
                          </Col>
                        )}

                        <Col className="col-12">
                          {editOptionsData?.map((option, index) => (
                            <div
                              className="form-check form-radio-primary mb-3 "
                              key={option?.value}
                            >
                              <Input
                                className="form-check-input"
                                type="radio"
                                name="kycOption"
                                value={option?.value}
                                checked={selectedOption == option?.value}
                                onChange={(e) =>
                                  setSelectedOption(e.target.value)
                                }
                                disabled={option?.disabled}
                              />
                              <Label className="form-check-label">
                                {option?.label}
                                <p className="text-muted mt-0 mb-0">
                                  {option?.description}
                                </p>
                              </Label>
                            </div>
                          ))}
                        </Col>
                        <Col xxl={12}>
                          <div className="text-end">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleContinue}
                            >
                              Continue
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditOptions;
